import type { Thunk } from 'types/redux'
import { autosave } from '@disco/state-management/actions/campaign-editor-actions'
import {
  CAMPAIGN_RECIPIENT_ADD,
  CAMPAIGN_RECIPIENT_CHANGE,
  CAMPAIGN_RECIPIENT_MODE_SELECT,
  CAMPAIGN_RECIPIENT_REMOVE,
} from '@disco/constants/ActionTypes'
import type {
  MatchMode,
  RecipientRule,
} from '@disco/state-management/reducers/email-campaigns/recipient-rules'
/**
 * Selects the match mode for campaign recipient filtering.
 * @param matchMode - Mode for matching recipients (AND/OR logic)
 * @returns Thunk that updates recipient match mode with autosave
 */
export function campaignRecipientModeSelect(matchMode: MatchMode): Thunk {
  return autosave({
    type: CAMPAIGN_RECIPIENT_MODE_SELECT,
    matchMode,
  })
}
/**
 * Adds a new recipient rule to the campaign.
 * @param ruleType - Type of recipient rule to add
 * @returns Thunk that adds recipient rule with autosave
 */
export function campaignRecipientAdd(ruleType: string): Thunk {
  return autosave({
    type: CAMPAIGN_RECIPIENT_ADD,
    ruleType,
  })
}
/**
 * Removes a recipient rule from the campaign.
 * @param ruleId - ID of the recipient rule to remove
 * @returns Thunk that removes recipient rule with autosave
 */
export function campaignRecipientRemove(ruleId: string): Thunk {
  return autosave({
    type: CAMPAIGN_RECIPIENT_REMOVE,
    ruleId,
  })
}
/**
 * Updates an existing recipient rule with new values.
 * @param ruleId - ID of the recipient rule to update
 * @param updated - Partial recipient rule data to update
 * @returns Thunk that updates recipient rule with autosave
 */
export function campaignRecipientChange(
  ruleId: string,
  updated: Partial<RecipientRule>,
): Thunk {
  return autosave({
    type: CAMPAIGN_RECIPIENT_CHANGE,
    ruleId,
    updated,
  })
}
